<template>
  <div>
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="商品信息：">
        <el-cascader size="small" v-model="formInline.typeKeyId" :options="goodsTypeList" :props="cascaderProps"
          @change="handleTypeChange" placeholder="请选择商品信息" clearable filterable></el-cascader>
      </el-form-item>
      <el-form-item label="球镜">
        <el-select v-model="formInline.paramsKeyId1" placeholder="请选择球镜" clearable filterable size="small"
          @change="handleParamsChange">
          <el-option v-for="item in qiuJingList" :label="item.paramsValue" :value="item.keyId"
            :key="item.keyId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="柱镜">
        <el-select v-model="formInline.paramsKeyId2" placeholder="请选择柱镜" clearable filterable size="small"
          @change="handleParamsChange">
          <el-option v-for="item in zhuJingList" :label="item.paramsValue" :value="item.keyId"
            :key="item.keyId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商品位置：">
        <el-input size="small" @keyup.enter.native="inputChange" v-model="formInline.location"
          placeholder="请输入商品位置"></el-input>
      </el-form-item>
      <el-form-item label="是否预警：">
        <el-select v-model="formInline.isWarning" placeholder="请选择是否预警" size="small" width="100px">
          <el-option label="全部" key="0" :value="0"></el-option>
          <el-option label="是" key="1" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="this.$checkBtnPermission('/warehouse/index', 'viewPage')" size="small" type="primary"
          class="el-icon-search" @click="inputChange()">
          搜索
        </el-button>
        <el-button v-if="this.$checkBtnPermission('/warehouse/index', 'reset')" size="small" icon="el-icon-refresh"
          @click="clearAll">重置</el-button>
        <el-button v-if="this.$checkBtnPermission('/warehouse/index', 'editConfig')" size="small" type="primary"
          class="el-icon-edit" @click="handleEdit()">修改库存配置
        </el-button>
        <el-button v-if="this.$checkBtnPermission('/warehouse/index', 'export')" size="small" type="warning"
          class="el-icon-s-promotion" @click="handleExportStockWareHouse()">导出补货采购清单
        </el-button>
        <el-button v-if="this.$checkBtnPermission('/warehouse/index', 'exportRealWarehouse')" size="small"
          type="warning" class="el-icon-s-promotion" @click="handleExportRealWareHouse()">导出实时库存
        </el-button>
        <my-column-filter v-if="this.$checkBtnPermission('/warehouse/index', 'myFilter')" :listColumns="listColumns"
          @hidePop="getCheckBox"></my-column-filter>
      </el-form-item>
    </el-form>
    <STable :columns="columnsData" :data="listData" @getData="getListData" :loading="loading"
      @selection-change="handleSelectionChange" border @row-dblclick="handleRowClick">
      <el-table-column align="center" slot="quantity" label="库存数量" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.quantity < scope.row.warningQuantity" class="one_1">
            {{ scope.row.quantity }}
          </span>
          <span v-else>
            {{ scope.row.quantity }}
          </span>
        </template>
      </el-table-column>
    </STable>
    <!-- 分页组件 -->
    <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <createWarehouse ref="createWarehouse"></createWarehouse>

    <selectInOrOut ref="selectInOrOut"></selectInOrOut>
  </div>
</template>

<script>
import {
  GetGoodsWareHousePageList,
  ExportStockWarehouseGoods,
  ExportRealWarehouseGoods,
} from "@/api/storeOrderApi.js";
import createWarehouse from "@/views/baseData/goods/createWarehouse.vue";
import selectInOrOut from "./selectInOrOut.vue";
import { downloadFile } from "@/utils/export.js";
import {
  GetGoodsParamsList,
  GetAllGoodsTypeTreePageList,
} from "@/api/baseDataApi.js";
export default {
  data() {
    return {
      pageShow: true,
      loading: false, // 显示加载
      listData: [],
      selectionList: [],
      // 分页参数
      pageparm: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      formInline: {
        pageIndex: 1,
        pageSize: 10,
        typeKeyId: "",
        isWarning: 0,
        paramsKeyId1: "",
        paramsKeyId2: "",
        location: "",
      },
      columnsData: [], //显示列
      listColumns: [
        {
          prop: "keyId",
          label: "全选",
          align: "center",
          fixed: "left",
          width: "55",
          isKeep: true,
          selection: true,
        },
        {
          prop: "rowNumber",
          label: "序号",
          align: "center",
          fixed: "left",
          width: "80",
          isKeep: true,
        },
        {
          prop: "goodsInfo.type",
          label: "商品品牌",
          isKeep: true,
          fixed: "left",
          width: "120",
          align: "center",
        },
        {
          prop: "goodsInfo.name",
          label: "商品名称",
          fixed: "left",
          width: "240",
          align: "center",
        },
        {
          prop: "goodsInfo.qiuJing",
          label: "球镜",
          width: "100",
          align: "center",
        },
        {
          prop: "goodsInfo.zhuJing",
          label: "柱镜",
          width: "100",
          align: "center",
        },
        {
          slot: "quantity",
          label: "库存数量",
          width: "120",
          align: "center",
        },
        {
          prop: "warningQuantity",
          label: "预警数量",
          width: "120",
          align: "center",
        },
        {
          prop: "stockQuantity",
          label: "常备数量",
          width: "120",
          align: "center",
        },
        {
          prop: "location",
          label: "存放位置",
        },
        {
          prop: "creator",
          label: "创建人",
          width: "120",
          align: "center",
        },
        {
          prop: "createTime",
          label: "创建时间",
          width: "160",
          align: "center",
        },
        {
          prop: "editor",
          label: "维护人",
          width: "120",
          align: "center",
        },
        {
          prop: "updateTime",
          label: "维护时间",
          width: "160",
          align: "center",
        },
      ],
      chooseTime: "",
      storeList: [],
      stateList: [],
      goodsTypeList: [],
      qiuJingList: [],
      zhuJingList: [],
      cascaderProps: {
        value: "keyId", // 绑定值的属性名
        label: "name", // 显示文本的属性名
        children: "subList", // 子节点的属性名
        checkStrictly: false, // 可以选择任意一级
        expandTrigger: "click", // 展开方式
      },
    };
  },
  // 注册组件
  components: {
    createWarehouse,
    selectInOrOut
  },
  created() {
    // 初始列
    this.getCheckBox(this.listColumns.map((item) => item.label));
    this.getListData();
    this.GetAllGoodsTypeTreePageList();
    this.GetGoodsParamsList();
  },
  computed: {},
  methods: {
    // 获取筛选框
    getCheckBox(val) {
      let arr = this.listColumns.filter((v) => !val.includes(v.label));
      this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
    },
    handleEdit() {
      if (this.selectionList.length == 0) {
        this.$message({
          type: "info",
          message: "请选择要修改的库存商品信息！",
        });
        return;
      }
      this.$refs.createWarehouse.showCreateWarehouseDialog(
        this.selectionList,
        true
      );
    },
    handleSelectionChange(val) {
      if (val == null || val == undefined || val.length == 0) {
        this.selectionList = [];
      } else {
        this.selectionList = val.map((item) => item.keyId);
      }
    },
    changePages() { },
    handleCommand(command) {
      // 1编辑
      switch (command.command) {
        case "4":
          this.deleteInfo(command.rowData);
          break;
        default:
          console.log(command);
      }
    },
    // 单击行数据
    handleRowClick(row) {
      this.$refs.selectInOrOut.showRecordDialog(row.goodsKeyId);
    },
    // 获取列表
    getListData() {
      this.loading = true;
      GetGoodsWareHousePageList(this.formInline)
        .then((res) => {
          if (res.code == 1) {
            this.loading = false;
            this.listData = res.data;
            this.pageparm.total = res.totalNumber;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    // 重置
    clearAll() {
      this.$data.formInline = this.$options.data.call(this).formInline;
      this.search();
    },
    inputChange(val) {
      this.search();
    },
    // 分页插件事件
    callFather(parm) {
      if (parm.currentPage == undefined) {
        this.formInline.pageIndex = 1;
      } else {
        this.formInline.pageIndex = parm.currentPage;
      }
      this.formInline.pageSize = parm.pageSize;
      this.getListData();
    },
    // 搜索事件
    search() {
      this.formInline.pageIndex = 1;
      this.pageShow = false;
      this.$nextTick(() => {
        this.pageShow = true;
      });
      this.getListData();
    },
    handleExportStockWareHouse() {
      this.$confirm("确定导出需要采购的库存商品信息吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        ExportStockWarehouseGoods({
          keyId: this.formInline.typeKeyId,
        })
          .then((res) => {
            if (res.code === 1) {
              let fileName = res.data
                ? res.data.substring(res.data.lastIndexOf("/") + 1)
                : "需采购的库存商品.xlsx";
              downloadFile(res.data, fileName);
              this.$message({
                type: "success",
                message: "导出成功!",
              });
              this.getListData();
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$message.error("导出失败，请稍后再试！");
          });
      });
    },
    // 获取商品类型数据
    GetAllGoodsTypeTreePageList() {
      GetAllGoodsTypeTreePageList({})
        .then((res) => {
          if (res.code == 1) {
            this.goodsTypeList = res.data;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    //获取商品参数信息
    GetGoodsParamsList() {
      GetGoodsParamsList({})
        .then((res) => {
          if (res.code == 1) {
            this.qiuJingList = res.data.filter((item) => item.type == 1);
            this.zhuJingList = res.data.filter((item) => item.type == 2);
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    // 处理商品参数选择变化
    handleParamsChange(value) {
      this.search();
    },
    // 处理商品类型选择变化
    handleTypeChange(value) {
      if (value && value.length > 0) {
        // 取最后一级的值作为typeKeyId
        this.formInline.typeKeyId = value[value.length - 1];
      } else {
        this.formInline.typeKeyId = "";
      }
      this.search();
    },
    // 导出实时库存
    handleExportRealWareHouse() {
      this.$confirm("确定导出需要实时库存信息吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        ExportRealWarehouseGoods({
        })
          .then((res) => {
            if (res.code === 1) {
              var url = localStorage.getItem("filePath");
              let fileName = res.data
                ? res.data.substring(res.data.lastIndexOf("/") + 1)
                : ("实时库存商品_" + new Date().getTime() + ".xlsx");
              downloadFile(url + res.data, fileName);
              this.$message({
                type: "success",
                message: "导出成功!",
              });
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$message.error("导出失败，请稍后再试！");
          });
      })
    }
  },
};
</script>

<style scoped>
.one_1 {
  background-color: rgb(255, 0, 0);
  display: block;
  color: white;
  font-weight: bolder;
}
</style>